// extracted by mini-css-extract-plugin
export default {"confirmModal":"styles_confirmModal__dxjEy","modalTitle":"styles_modalTitle__lbSeX","buttons":"styles_buttons__Op-sn"};